exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss"), undefined);

// module
exports.push([module.id, ".PostComments__underline___3ExR8 {\n\tborder-bottom: 1px solid #ccc;\n}\n\n.PostComments__form___1j41Z {\n\tpadding: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n}\n\n.PostComments__noPosts___3vsPY {\n\tpadding: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + "",
	"underline": "PostComments__underline___3ExR8",
	"form": "PostComments__form___1j41Z",
	"noPosts": "PostComments__noPosts___3vsPY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/PostComments.icss
// module id = 1508
// module chunks = 0